import { useEffect, useSyncExternalStore } from 'react';

let mounted = 0;
const listeners = new Set<() => void>();

const notify = () => {
  listeners.forEach(listener => {
    listener();
  });
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getIsShowing = () => mounted > 0;

/** Counts the calling component as a loading screen while it is mounted. */
export const useRegisterLoadingScreen = () => {
  useEffect(() => {
    mounted += 1;
    notify();
    return () => {
      mounted -= 1;
      notify();
    };
  }, []);
};

/** True while any loading screen is mounted anywhere in the app. */
export const useIsLoadingScreenShowing = () =>
  useSyncExternalStore(subscribe, getIsShowing, getIsShowing);
